export default "__VITE_ASSET__BjbzJFkM__"